import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaCalendarCheck, FaUserMd, FaTooth, FaChartLine, FaShieldAlt,
  FaClipboardList, FaCashRegister, FaUsers, FaFileMedical,
  FaBell, FaMobileAlt, FaCloudDownloadAlt,
} from 'react-icons/fa';
import styles from './Sanarix.module.css';
import PageSEO from '../../components/PageSEO/PageSEO';

const Sanarix = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'pt';

  const features = [
    { icon: <FaCalendarCheck />, title: t('sanarix.r1'), description: t('sanarix.r1Desc') },
    { icon: <FaUserMd />,        title: t('sanarix.r2'), description: t('sanarix.r2Desc') },
    { icon: <FaTooth />,         title: t('sanarix.r3'), description: t('sanarix.r3Desc') },
    { icon: <FaCashRegister />,  title: t('sanarix.r4'), description: t('sanarix.r4Desc') },
    { icon: <FaClipboardList />, title: t('sanarix.r5'), description: t('sanarix.r5Desc') },
    { icon: <FaChartLine />,     title: t('sanarix.r6'), description: t('sanarix.r6Desc') },
  ];

  const extraFeatures = [
    { icon: <FaUsers />,           text: t('sanarix.extra1') },
    { icon: <FaFileMedical />,     text: t('sanarix.extra2') },
    { icon: <FaBell />,            text: t('sanarix.extra3') },
    { icon: <FaShieldAlt />,       text: t('sanarix.extra4') },
    { icon: <FaMobileAlt />,       text: t('sanarix.extra5') },
    { icon: <FaCloudDownloadAlt />,text: t('sanarix.extra6') },
  ];

  const handleContact = () => { window.location.href = '/Contato'; };

  return (
    <div className={styles.container}>
      <PageSEO
        title="Sanarix — Gestão para Clínicas e Consultórios"
        description="Sistema completo para clínicas médicas e odontológicas: agenda inteligente, prontuário eletrônico, odontograma digital, financeiro, fila de atendimento e muito mais. 100% na nuvem."
        path="/Sanarix"
        lang={lang}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Sanarix',
          applicationCategory: 'MedicalApplication',
          operatingSystem: 'Web',
          description: 'Sistema de gestão completo para clínicas médicas e odontológicas.',
          url: 'https://steinsoft.com.br/Sanarix',
        }}
      />
      {/* Hero */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>
            <span className={styles.productName}>Sanarix</span>
            <span className={styles.tagline}>{t('sanarix.titulo')}</span>
          </h1>
          <p className={styles.subtitle}>{t('sanarix.subtitulo')}</p>
          <div className={styles.heroButtons}>
            <button className={styles.primaryButton} onClick={handleContact}>
              {t('sanarix.btnDemo')}
            </button>
          </div>
        </div>
        <div className={styles.heroVisual}>
          <div className={styles.heroIcon}><FaUserMd /></div>
        </div>
      </section>

      {/* Features */}
      <section className={styles.features}>
        <h2 className={styles.sectionTitle}>{t('sanarix.recursos')}</h2>
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.featureIcon}>{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Extra Features */}
      <section className={styles.extras}>
        <h2 className={styles.sectionTitle}>{t('sanarix.emaisTitulo')}</h2>
        <div className={styles.extrasGrid}>
          {extraFeatures.map((item, index) => (
            <div key={index} className={styles.extraItem}>
              <div className={styles.extraIcon}>{item.icon}</div>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className={styles.cta}>
        <h2>{t('sanarix.ctaTitulo')}</h2>
        <p>{t('sanarix.ctaDesc')}</p>
        <button className={styles.ctaButton} onClick={handleContact}>
          {t('sanarix.ctaBtn')}
        </button>
      </section>
    </div>
  );
};

export default Sanarix;
